/* @generated */	
// prettier-ignore
if (Intl.DateTimeFormat && typeof Intl.DateTimeFormat.__addLocaleData === 'function') {
  Intl.DateTimeFormat.__addLocaleData({
  "data": {
    "am": "AM",
    "pm": "PM",
    "weekday": {
      "narrow": [
        "ഞ",
        "തി",
        "ചൊ",
        "ബു",
        "വ്യാ",
        "വെ",
        "ശ"
      ],
      "short": [
        "ഞായർ",
        "തിങ്കൾ",
        "ചൊവ്വ",
        "ബുധൻ",
        "വ്യാഴം",
        "വെള്ളി",
        "ശനി"
      ],
      "long": [
        "ഞായറാഴ്‌ച",
        "തിങ്കളാഴ്‌ച",
        "ചൊവ്വാഴ്ച",
        "ബുധനാഴ്‌ച",
        "വ്യാഴാഴ്‌ച",
        "വെള്ളിയാഴ്‌ച",
        "ശനിയാഴ്‌ച"
      ]
    },
    "era": {
      "narrow": {
        "BC": "ക്രി.മു.",
        "AD": "എഡി"
      },
      "short": {
        "BC": "ക്രി.മു.",
        "AD": "എഡി"
      },
      "long": {
        "BC": "ക്രിസ്‌തുവിന് മുമ്പ്",
        "AD": "ആന്നോ ഡൊമിനി"
      }
    },
    "month": {
      "narrow": [
        "ജ",
        "ഫെ",
        "മാ",
        "ഏ",
        "മെ",
        "ജൂൺ",
        "ജൂ",
        "ഓ",
        "സെ",
        "ഒ",
        "ന",
        "ഡി"
      ],
      "short": [
        "ജനു",
        "ഫെബ്രു",
        "മാർ",
        "ഏപ്രി",
        "മേയ്",
        "ജൂൺ",
        "ജൂലൈ",
        "ഓഗ",
        "സെപ്റ്റം",
        "ഒക്ടോ",
        "നവം",
        "ഡിസം"
      ],
      "long": [
        "ജനുവരി",
        "ഫെബ്രുവരി",
        "മാർച്ച്",
        "ഏപ്രിൽ",
        "മേയ്",
        "ജൂൺ",
        "ജൂലൈ",
        "ഓഗസ്റ്റ്",
        "സെപ്റ്റംബർ",
        "ഒക്‌ടോബർ",
        "നവംബർ",
        "ഡിസംബർ"
      ]
    },
    "timeZoneName": {
      "America/Rio_Branco": {
        "long": [
          "എയ്ക്കർ സ്റ്റാൻഡേർഡ് സമയം",
          "എയ്ക്കർ വേനൽക്കാല സമയം"
        ]
      },
      "Asia/Kabul": {
        "long": [
          "അഫ്‌ഗാനിസ്ഥാൻ സമയം",
          "അഫ്‌ഗാനിസ്ഥാൻ സമയം"
        ]
      },
      "Africa/Maputo": {
        "long": [
          "മധ്യ ആഫ്രിക്ക സമയം",
          "മധ്യ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Bujumbura": {
        "long": [
          "മധ്യ ആഫ്രിക്ക സമയം",
          "മധ്യ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Gaborone": {
        "long": [
          "മധ്യ ആഫ്രിക്ക സമയം",
          "മധ്യ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Lubumbashi": {
        "long": [
          "മധ്യ ആഫ്രിക്ക സമയം",
          "മധ്യ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Blantyre": {
        "long": [
          "മധ്യ ആഫ്രിക്ക സമയം",
          "മധ്യ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Kigali": {
        "long": [
          "മധ്യ ആഫ്രിക്ക സമയം",
          "മധ്യ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Lusaka": {
        "long": [
          "മധ്യ ആഫ്രിക്ക സമയം",
          "മധ്യ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Harare": {
        "long": [
          "മധ്യ ആഫ്രിക്ക സമയം",
          "മധ്യ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Nairobi": {
        "long": [
          "കിഴക്കൻ ആഫ്രിക്ക സമയം",
          "കിഴക്കൻ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Djibouti": {
        "long": [
          "കിഴക്കൻ ആഫ്രിക്ക സമയം",
          "കിഴക്കൻ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Asmera": {
        "long": [
          "കിഴക്കൻ ആഫ്രിക്ക സമയം",
          "കിഴക്കൻ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Addis_Ababa": {
        "long": [
          "കിഴക്കൻ ആഫ്രിക്ക സമയം",
          "കിഴക്കൻ ആഫ്രിക്ക സമയം"
        ]
      },
      "Indian/Comoro": {
        "long": [
          "കിഴക്കൻ ആഫ്രിക്ക സമയം",
          "കിഴക്കൻ ആഫ്രിക്ക സമയം"
        ]
      },
      "Indian/Antananarivo": {
        "long": [
          "കിഴക്കൻ ആഫ്രിക്ക സമയം",
          "കിഴക്കൻ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Mogadishu": {
        "long": [
          "കിഴക്കൻ ആഫ്രിക്ക സമയം",
          "കിഴക്കൻ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Dar_es_Salaam": {
        "long": [
          "കിഴക്കൻ ആഫ്രിക്ക സമയം",
          "കിഴക്കൻ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Kampala": {
        "long": [
          "കിഴക്കൻ ആഫ്രിക്ക സമയം",
          "കിഴക്കൻ ആഫ്രിക്ക സമയം"
        ]
      },
      "Indian/Mayotte": {
        "long": [
          "കിഴക്കൻ ആഫ്രിക്ക സമയം",
          "കിഴക്കൻ ആഫ്രിക്ക സമയം"
        ]
      },
      "Africa/Johannesburg": {
        "long": [
          "ദക്ഷിണാഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "ദക്ഷിണാഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം"
        ]
      },
      "Africa/Maseru": {
        "long": [
          "ദക്ഷിണാഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "ദക്ഷിണാഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം"
        ]
      },
      "Africa/Mbabane": {
        "long": [
          "ദക്ഷിണാഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "ദക്ഷിണാഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം"
        ]
      },
      "Africa/Lagos": {
        "long": [
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Africa/Luanda": {
        "long": [
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Africa/Porto-Novo": {
        "long": [
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Africa/Kinshasa": {
        "long": [
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Africa/Bangui": {
        "long": [
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Africa/Brazzaville": {
        "long": [
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Africa/Douala": {
        "long": [
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Africa/Libreville": {
        "long": [
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Africa/Malabo": {
        "long": [
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Africa/Niamey": {
        "long": [
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Africa/Ndjamena": {
        "long": [
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ ആഫ്രിക്ക ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Aqtobe": {
        "long": [
          "പടിഞ്ഞാറൻ കസാഖിസ്ഥാൻ സമയം",
          "പടിഞ്ഞാറൻ കസാഖിസ്ഥാൻ സമയം"
        ]
      },
      "America/Juneau": {
        "long": [
          "അലാസ്ക സ്റ്റാൻഡേർഡ് സമയം",
          "അലാസ്‌ക ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Almaty": {
        "long": [
          "കിഴക്കൻ കസാഖിസ്ഥാൻ സമയം",
          "കിഴക്കൻ കസാഖിസ്ഥാൻ സമയം"
        ]
      },
      "America/Manaus": {
        "long": [
          "ആമസോൺ സ്റ്റാൻഡേർഡ് സമയം",
          "ആമസോൺ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "America/Chicago": {
        "long": [
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Belize": {
        "long": [
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Winnipeg": {
        "long": [
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Costa_Rica": {
        "long": [
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Guatemala": {
        "long": [
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Tegucigalpa": {
        "long": [
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Mexico_City": {
        "long": [
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/El_Salvador": {
        "long": [
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ സെൻട്രൽ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/New_York": {
        "long": [
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Nassau": {
        "long": [
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Toronto": {
        "long": [
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Port-au-Prince": {
        "long": [
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Jamaica": {
        "long": [
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Cayman": {
        "long": [
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Panama": {
        "long": [
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ കിഴക്കൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Denver": {
        "long": [
          "വടക്കെ അമേരിക്കൻ മൗണ്ടൻ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ മൗണ്ടൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Edmonton": {
        "long": [
          "വടക്കെ അമേരിക്കൻ മൗണ്ടൻ സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ മൗണ്ടൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Los_Angeles": {
        "long": [
          "വടക്കെ അമേരിക്കൻ പസഫിക് സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ പസഫിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Vancouver": {
        "long": [
          "വടക്കെ അമേരിക്കൻ പസഫിക് സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ പസഫിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Tijuana": {
        "long": [
          "വടക്കെ അമേരിക്കൻ പസഫിക് സ്റ്റാൻഡേർഡ് സമയം",
          "വടക്കെ അമേരിക്കൻ പസഫിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Anadyr": {
        "long": [
          "അനാഡിർ സ്റ്റാൻഡേർഡ് സമയം",
          "അനാഡിർ വേനൽക്കാല സമയം"
        ]
      },
      "Pacific/Apia": {
        "long": [
          "അപിയ സ്റ്റാൻഡേർഡ് സമയം",
          "അപിയ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Riyadh": {
        "long": [
          "അറേബ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "അറേബ്യൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Bahrain": {
        "long": [
          "അറേബ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "അറേബ്യൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Baghdad": {
        "long": [
          "അറേബ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "അറേബ്യൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Kuwait": {
        "long": [
          "അറേബ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "അറേബ്യൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Qatar": {
        "long": [
          "അറേബ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "അറേബ്യൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Aden": {
        "long": [
          "അറേബ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "അറേബ്യൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Buenos_Aires": {
        "long": [
          "അർജന്റീന സ്റ്റാൻഡേർഡ് സമയം",
          "അർജന്റീന ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "America/Argentina/San_Luis": {
        "long": [
          "പടിഞ്ഞാറൻ അർജന്റീന സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ അർജന്റീന ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Ashgabat": {
        "long": [
          "തുർക്ക്‌മെനിസ്ഥാൻ സ്റ്റാൻഡേർഡ് സമയം",
          "തുർക്ക്‌മെനിസ്ഥാൻ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "America/Halifax": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Antigua": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Anguilla": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Aruba": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Barbados": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "Atlantic/Bermuda": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Kralendijk": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Curacao": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Dominica": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Grenada": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Thule": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Guadeloupe": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/St_Kitts": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/St_Lucia": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Marigot": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Martinique": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Montserrat": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Puerto_Rico": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Lower_Princes": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Port_of_Spain": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/St_Vincent": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Tortola": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/St_Thomas": {
        "long": [
          "അറ്റ്‌ലാന്റിക് സ്റ്റാൻഡേർഡ് സമയം",
          "അറ്റ്‌ലാന്റിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "Australia/Adelaide": {
        "long": [
          "ഓസ്ട്രേലിയൻ സെൻട്രൽ സ്റ്റാൻഡേർഡ് സമയം",
          "ഓസ്ട്രേലിയൻ സെൻട്രൽ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Australia/Eucla": {
        "long": [
          "ഓസ്ട്രേലിയൻ സെൻട്രൽ പടിഞ്ഞാറൻ സ്റ്റാൻഡേർഡ് സമയം",
          "ഓസ്ട്രേലിയൻ സെൻട്രൽ പടിഞ്ഞാറൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Australia/Sydney": {
        "long": [
          "ഓസ്‌ട്രേലിയൻ കിഴക്കൻ സ്റ്റാൻഡേർഡ് സമയം",
          "ഓസ്‌ട്രേലിയൻ കിഴക്കൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Australia/Perth": {
        "long": [
          "ഓസ്‌ട്രേലിയൻ പടിഞ്ഞാറൻ സ്റ്റാൻഡേർഡ് സമയം",
          "ഓസ്‌ട്രേലിയൻ പടിഞ്ഞാറൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Atlantic/Azores": {
        "long": [
          "അസോർസ് സ്റ്റാൻഡേർഡ് സമയം",
          "അസോർസ് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Thimphu": {
        "long": [
          "ഭൂട്ടാൻ സമയം",
          "ഭൂട്ടാൻ സമയം"
        ]
      },
      "America/La_Paz": {
        "long": [
          "ബൊളീവിയ സമയം",
          "ബൊളീവിയ സമയം"
        ]
      },
      "Asia/Kuching": {
        "long": [
          "മലേഷ്യ സമയം",
          "മലേഷ്യ സമയം"
        ]
      },
      "America/Sao_Paulo": {
        "long": [
          "ബ്രസീലിയ സ്റ്റാൻഡേർഡ് സമയം",
          "ബ്രസീലിയ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Europe/London": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "Asia/Brunei": {
        "long": [
          "ബ്രൂണൈ ദാറുസ്സലാം സമയം",
          "ബ്രൂണൈ ദാറുസ്സലാം സമയം"
        ]
      },
      "Atlantic/Cape_Verde": {
        "long": [
          "കേപ് വെർദെ സ്റ്റാൻഡേർഡ് സമയം",
          "കേപ് വെർദെ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Pacific/Saipan": {
        "long": [
          "നോർത്ത് മറിയാനാ ദ്വീപുകൾ സമയം",
          "നോർത്ത് മറിയാനാ ദ്വീപുകൾ സമയം"
        ]
      },
      "Pacific/Guam": {
        "long": [
          "ഗ്വാം സ്റ്റാൻഡേർഡ് സമയം",
          "ഗ്വാം സ്റ്റാൻഡേർഡ് സമയം"
        ]
      },
      "Pacific/Chatham": {
        "long": [
          "ചാത്തം സ്റ്റാൻഡേർഡ് സമയം",
          "ചാത്തം ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "America/Santiago": {
        "long": [
          "ചിലി സ്റ്റാൻഡേർഡ് സമയം",
          "ചിലി ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Shanghai": {
        "long": [
          "ചൈന സ്റ്റാൻഡേർഡ് സമയം",
          "ചൈന ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Choibalsan": {
        "long": [
          "ചോയ്‌ബൽസാൻ സ്റ്റാൻഡേർഡ് സമയം",
          "ചോയിബൽസാൻ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Indian/Christmas": {
        "long": [
          "ക്രിസ്‌മസ് ദ്വീപ് സമയം",
          "ക്രിസ്‌മസ് ദ്വീപ് സമയം"
        ]
      },
      "Indian/Cocos": {
        "long": [
          "കൊക്കോസ് ദ്വീപുകൾ സമയം",
          "കൊക്കോസ് ദ്വീപുകൾ സമയം"
        ]
      },
      "America/Bogota": {
        "long": [
          "കൊളംബിയ സ്റ്റാൻഡേർഡ് സമയം",
          "കൊളംബിയ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Pacific/Rarotonga": {
        "long": [
          "കുക്ക് ദ്വീപുകൾ സ്റ്റാൻഡേർഡ് സമയം",
          "കുക്ക് ദ്വീപുകൾ അർദ്ധ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "America/Havana": {
        "long": [
          "ക്യൂബ സ്റ്റാൻഡേർഡ് സമയം",
          "ക്യൂബ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Antarctica/Davis": {
        "long": [
          "ഡേവിസ് സമയം",
          "ഡേവിസ് സമയം"
        ]
      },
      "Antarctica/DumontDUrville": {
        "long": [
          "ഡുമോണ്ട് ഡി ഉർവില്ലെ സമയം",
          "ഡുമോണ്ട് ഡി ഉർവില്ലെ സമയം"
        ]
      },
      "Asia/Dushanbe": {
        "long": [
          "താജിക്കിസ്ഥാൻ സമയം",
          "താജിക്കിസ്ഥാൻ സമയം"
        ]
      },
      "America/Paramaribo": {
        "long": [
          "സുരിനെയിം സമയം",
          "സുരിനെയിം സമയം"
        ]
      },
      "Asia/Dili": {
        "long": [
          "കിഴക്കൻ തിമോർ സമയം",
          "കിഴക്കൻ തിമോർ സമയം"
        ]
      },
      "Pacific/Easter": {
        "long": [
          "ഈസ്റ്റർ ദ്വീപ് സ്റ്റാൻഡേർഡ് സമയം",
          "ഈസ്റ്റർ ദ്വീപ് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "America/Guayaquil": {
        "long": [
          "ഇക്വഡോർ സമയം",
          "ഇക്വഡോർ സമയം"
        ]
      },
      "Europe/Paris": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Andorra": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Tirane": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Vienna": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Sarajevo": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Brussels": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Zurich": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Prague": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Berlin": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Copenhagen": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Madrid": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Gibraltar": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Zagreb": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Budapest": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Rome": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Vaduz": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Luxembourg": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Monaco": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Podgorica": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Skopje": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Malta": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Amsterdam": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Oslo": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Warsaw": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Belgrade": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Stockholm": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Ljubljana": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Arctic/Longyearbyen": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Bratislava": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/San_Marino": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Africa/Tunis": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Vatican": {
        "long": [
          "സെൻട്രൽ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെൻട്രൽ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Bucharest": {
        "long": [
          "കിഴക്കൻ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "കിഴക്കൻ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Mariehamn": {
        "long": [
          "കിഴക്കൻ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "കിഴക്കൻ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Sofia": {
        "long": [
          "കിഴക്കൻ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "കിഴക്കൻ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Asia/Nicosia": {
        "long": [
          "കിഴക്കൻ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "കിഴക്കൻ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Africa/Cairo": {
        "long": [
          "കിഴക്കൻ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "കിഴക്കൻ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Helsinki": {
        "long": [
          "കിഴക്കൻ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "കിഴക്കൻ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Athens": {
        "long": [
          "കിഴക്കൻ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "കിഴക്കൻ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Asia/Beirut": {
        "long": [
          "കിഴക്കൻ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "കിഴക്കൻ യൂറോപ്യൻ ഗ്രീഷ്മകാല സമയം"
        ]
      },
      "Europe/Minsk": {
        "long": [
          "കിഴക്കേയറ്റത്തെ യൂറോപ്യൻ സമയം",
          "കിഴക്കേയറ്റത്തെ യൂറോപ്യൻ സമയം"
        ]
      },
      "Europe/Kaliningrad": {
        "long": [
          "കിഴക്കേയറ്റത്തെ യൂറോപ്യൻ സമയം",
          "കിഴക്കേയറ്റത്തെ യൂറോപ്യൻ സമയം"
        ]
      },
      "Atlantic/Canary": {
        "long": [
          "പടിഞ്ഞാറൻ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ യൂറോപ്യൻ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Atlantic/Faeroe": {
        "long": [
          "പടിഞ്ഞാറൻ യൂറോപ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ യൂറോപ്യൻ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Atlantic/Stanley": {
        "long": [
          "ഫാക്ക്‌ലാൻഡ് ദ്വീപുകൾ സ്റ്റാൻഡേർഡ് സമയം",
          "ഫാക്ക്‌ലാൻഡ് ദ്വീപുകൾ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Pacific/Fiji": {
        "long": [
          "ഫിജി സ്റ്റാൻഡേർഡ് സമയം",
          "ഫിജി ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "America/Cayenne": {
        "long": [
          "ഫ്രഞ്ച് ഗയാന സമയം",
          "ഫ്രഞ്ച് ഗയാന സമയം"
        ]
      },
      "Indian/Kerguelen": {
        "long": [
          "ഫ്രഞ്ച് സതേൺ, അന്റാർട്ടിക് സമയം",
          "ഫ്രഞ്ച് സതേൺ, അന്റാർട്ടിക് സമയം"
        ]
      },
      "Asia/Bishkek": {
        "long": [
          "കിർഗിസ്ഥാൻ സമയം",
          "കിർഗിസ്ഥാൻ സമയം"
        ]
      },
      "Pacific/Galapagos": {
        "long": [
          "ഗാലപ്പഗോസ് സമയം",
          "ഗാലപ്പഗോസ് സമയം"
        ]
      },
      "Pacific/Gambier": {
        "long": [
          "ഗാമ്പിയർ സമയം",
          "ഗാമ്പിയർ സമയം"
        ]
      },
      "Pacific/Tarawa": {
        "long": [
          "ഗിൽബേർട്ട് ദ്വീപുകൾ സമയം",
          "ഗിൽബേർട്ട് ദ്വീപുകൾ സമയം"
        ]
      },
      "Atlantic/Reykjavik": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "Africa/Ouagadougou": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "Africa/Abidjan": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "Africa/Accra": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "Africa/Banjul": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "Africa/Conakry": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "Africa/Bamako": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "Africa/Nouakchott": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "Atlantic/St_Helena": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "Africa/Freetown": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "Africa/Dakar": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "Africa/Lome": {
        "long": [
          "ഗ്രീൻവിച്ച് മീൻ സമയം",
          "ഗ്രീൻവിച്ച് മീൻ സമയം"
        ]
      },
      "America/Godthab": {
        "long": [
          "പടിഞ്ഞാറൻ ഗ്രീൻലാൻഡ് സ്റ്റാൻഡേർഡ് സമയം",
          "പടിഞ്ഞാറൻ ഗ്രീൻലാൻഡ് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "America/Scoresbysund": {
        "long": [
          "കിഴക്കൻ ഗ്രീൻലാൻഡ് സ്റ്റാൻഡേർഡ് സമയം",
          "കിഴക്കൻ ഗ്രീൻലാൻഡ് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Dubai": {
        "long": [
          "ഗൾഫ് സ്റ്റാൻഡേർഡ് സമയം",
          "ഗൾഫ് സ്റ്റാൻഡേർഡ് സമയം"
        ]
      },
      "Asia/Muscat": {
        "long": [
          "ഗൾഫ് സ്റ്റാൻഡേർഡ് സമയം",
          "ഗൾഫ് സ്റ്റാൻഡേർഡ് സമയം"
        ]
      },
      "America/Guyana": {
        "long": [
          "ഗയാന സമയം",
          "ഗയാന സമയം"
        ]
      },
      "Pacific/Honolulu": {
        "long": [
          "ഹവായ്-അലൂഷ്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "ഹവായ്-അലൂഷ്യൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Hong_Kong": {
        "long": [
          "ഹോങ്കോങ്ങ് സ്റ്റാൻഡേർഡ് സമയം",
          "ഹോങ്കോങ്ങ് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Hovd": {
        "long": [
          "ഹോഡ് സ്റ്റാൻഡേർഡ് സമയം",
          "ഹോഡ് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Calcutta": {
        "long": [
          "ഇന്ത്യൻ സ്റ്റാൻഡേർഡ് സമയം",
          "ഇന്ത്യൻ സ്റ്റാൻഡേർഡ് സമയം"
        ],
        "short": [
          "IST",
          "IST"
        ]
      },
      "Asia/Colombo": {
        "long": [
          "ലങ്ക സമയം",
          "ലങ്ക സമയം"
        ]
      },
      "Indian/Chagos": {
        "long": [
          "ഇന്ത്യൻ മഹാസമുദ്ര സമയം",
          "ഇന്ത്യൻ മഹാസമുദ്ര സമയം"
        ]
      },
      "Asia/Bangkok": {
        "long": [
          "ഇൻഡോചൈന സമയം",
          "ഇൻഡോചൈന സമയം"
        ]
      },
      "Asia/Phnom_Penh": {
        "long": [
          "ഇൻഡോചൈന സമയം",
          "ഇൻഡോചൈന സമയം"
        ]
      },
      "Asia/Vientiane": {
        "long": [
          "ഇൻഡോചൈന സമയം",
          "ഇൻഡോചൈന സമയം"
        ]
      },
      "Asia/Makassar": {
        "long": [
          "മധ്യ ഇന്തോനേഷ്യ സമയം",
          "മധ്യ ഇന്തോനേഷ്യ സമയം"
        ]
      },
      "Asia/Jayapura": {
        "long": [
          "കിഴക്കൻ ഇന്തോനേഷ്യ സമയം",
          "കിഴക്കൻ ഇന്തോനേഷ്യ സമയം"
        ]
      },
      "Asia/Jakarta": {
        "long": [
          "പടിഞ്ഞാറൻ ഇന്തോനേഷ്യ സമയം",
          "പടിഞ്ഞാറൻ ഇന്തോനേഷ്യ സമയം"
        ]
      },
      "Asia/Tehran": {
        "long": [
          "ഇറാൻ സ്റ്റാൻഡേർഡ് സമയം",
          "ഇറാൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Irkutsk": {
        "long": [
          "ഇർകസ്ക് സ്റ്റാൻഡേർഡ് സമയം",
          "ഇർകസ്‌ക് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Jerusalem": {
        "long": [
          "ഇസ്രായേൽ സ്റ്റാൻഡേർഡ് സമയം",
          "ഇസ്രായേൽ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Tokyo": {
        "long": [
          "ജപ്പാൻ സ്റ്റാൻഡേർഡ് സമയം",
          "ജപ്പാൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Kamchatka": {
        "long": [
          "പെട്രോപാവ്‌ലോസ്ക് കംചാസ്കി സ്റ്റാൻഡേർഡ് സമയം",
          "പെട്രോപാവ്‌ലോസ്ക് കംചാസ്കി വേനൽക്കാല സമയം"
        ]
      },
      "Asia/Karachi": {
        "long": [
          "പാക്കിസ്ഥാൻ സ്റ്റാൻഡേർഡ് സമയം",
          "പാക്കിസ്ഥാൻ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Qyzylorda": {
        "long": [
          "ഖിസിലോർഡ സ്റ്റാൻഡേർഡ് സമയം",
          "ഖിസിലോർഡ വേനൽക്കാല സമയം"
        ]
      },
      "Asia/Seoul": {
        "long": [
          "കൊറിയൻ സ്റ്റാൻഡേർഡ് സമയം",
          "കൊറിയൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Pacific/Kosrae": {
        "long": [
          "കൊസ്ര സമയം",
          "കൊസ്ര സമയം"
        ]
      },
      "Asia/Krasnoyarsk": {
        "long": [
          "ക്രാസ്‌നോയാർസ്‌ക് സ്റ്റാൻഡേർഡ് സമയം",
          "ക്രാസ്‌നോയാർസ്‌ക് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Europe/Samara": {
        "long": [
          "സമാറ സ്റ്റാൻഡേർഡ് സമയം",
          "സമാറ വേനൽക്കാല സമയം"
        ]
      },
      "Pacific/Kiritimati": {
        "long": [
          "ലൈൻ ദ്വീപുകൾ സമയം",
          "ലൈൻ ദ്വീപുകൾ സമയം"
        ]
      },
      "Australia/Lord_Howe": {
        "long": [
          "ലോർഡ് ഹോവ് സ്റ്റാൻഡേർഡ് സമയം",
          "ലോർഡ് ഹോവ് ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Macau": {
        "long": [
          "മകൌ സ്റ്റാൻഡേർഡ് സമയം",
          "മകൌ വേനൽക്കാല സമയം"
        ]
      },
      "Asia/Magadan": {
        "long": [
          "മഗാദൻ സ്റ്റാൻഡേർഡ് സമയം",
          "മഗാദൻ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Indian/Maldives": {
        "long": [
          "മാലിദ്വീപ് സമയം",
          "മാലിദ്വീപ് സമയം"
        ]
      },
      "Pacific/Marquesas": {
        "long": [
          "മർക്കസസ് സമയം",
          "മർക്കസസ് സമയം"
        ]
      },
      "Pacific/Majuro": {
        "long": [
          "മാർഷൽ ദ്വീപുകൾ സമയം",
          "മാർഷൽ ദ്വീപുകൾ സമയം"
        ]
      },
      "Indian/Mauritius": {
        "long": [
          "മൗറീഷ്യസ് സ്റ്റാൻഡേർഡ് സമയം",
          "മൗറീഷ്യസ് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Antarctica/Mawson": {
        "long": [
          "മാസൺ സമയം",
          "മാസൺ സമയം"
        ]
      },
      "America/Mazatlan": {
        "long": [
          "മെക്‌സിക്കൻ പസഫിക് സ്റ്റാൻഡേർഡ് സമയം",
          "മെക്സിക്കൻ പസഫിക് ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Ulaanbaatar": {
        "long": [
          "ഉലാൻബാത്തർ സ്റ്റാൻഡേർഡ് സമയം",
          "ഉലാൻബാത്തർ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Europe/Moscow": {
        "long": [
          "മോസ്കോ സ്റ്റാൻഡേർഡ് സമയം",
          "മോസ്‌കോ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Rangoon": {
        "long": [
          "മ്യാൻമാർ സമയം",
          "മ്യാൻമാർ സമയം"
        ]
      },
      "Pacific/Nauru": {
        "long": [
          "നൗറു സമയം",
          "നൗറു സമയം"
        ]
      },
      "Asia/Katmandu": {
        "long": [
          "നേപ്പാൾ സമയം",
          "നേപ്പാൾ സമയം"
        ]
      },
      "Pacific/Noumea": {
        "long": [
          "ന്യൂ കാലിഡോണിയ സ്റ്റാൻഡേർഡ് സമയം",
          "ന്യൂ കാലിഡോണിയ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Pacific/Auckland": {
        "long": [
          "ന്യൂസിലാൻഡ് സ്റ്റാൻഡേർഡ് സമയം",
          "ന്യൂസിലാൻഡ് ഡേലൈറ്റ് സമയം"
        ]
      },
      "Antarctica/McMurdo": {
        "long": [
          "ന്യൂസിലാൻഡ് സ്റ്റാൻഡേർഡ് സമയം",
          "ന്യൂസിലാൻഡ് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/St_Johns": {
        "long": [
          "ന്യൂഫൗണ്ട്‌ലാന്റ് സ്റ്റാൻഡേർഡ് സമയം",
          "ന്യൂഫൗണ്ട്‌ലാന്റ് ഡേലൈറ്റ് സമയം"
        ]
      },
      "Pacific/Niue": {
        "long": [
          "ന്യൂയി സമയം",
          "ന്യൂയി സമയം"
        ]
      },
      "Pacific/Norfolk": {
        "long": [
          "നോർ‌ഫോക്ക് ദ്വീപ് സ്റ്റാൻഡേർഡ് സമയം",
          "നോർ‌ഫോക്ക് ദ്വീപ് ഡേലൈറ്റ് സമയം"
        ]
      },
      "America/Noronha": {
        "long": [
          "ഫെർണാഡോ ഡി നൊറോൻഹ സ്റ്റാൻഡേർഡ് സമയം",
          "ഫെർണാഡോ ഡി നൊറോൻഹ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Novosibirsk": {
        "long": [
          "നോവോസിബിർസ്ക് സ്റ്റാൻഡേർഡ് സമയം",
          "നോവോസിബിർസ്‌ക് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Omsk": {
        "long": [
          "ഓംസ്‌ക്ക് സ്റ്റാൻഡേർഡ് സമയം",
          "ഓംസ്‌ക്ക് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Pacific/Palau": {
        "long": [
          "പലാവു സമയം",
          "പലാവു സമയം"
        ]
      },
      "Pacific/Port_Moresby": {
        "long": [
          "പാപ്പുവ ന്യൂ ഗിനിയ സമയം",
          "പാപ്പുവ ന്യൂ ഗിനിയ സമയം"
        ]
      },
      "America/Asuncion": {
        "long": [
          "പരാഗ്വേ സ്റ്റാൻഡേർഡ് സമയം",
          "പരാഗ്വേ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "America/Lima": {
        "long": [
          "പെറു സ്റ്റാൻഡേർഡ് സമയം",
          "പെറു ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Asia/Manila": {
        "long": [
          "ഫിലിപ്പൈൻ സ്റ്റാൻഡേർഡ് സമയം",
          "ഫിലിപ്പൈൻ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Pacific/Enderbury": {
        "long": [
          "ഫിനിക്‌സ് ദ്വീപ് സമയം",
          "ഫിനിക്‌സ് ദ്വീപ് സമയം"
        ]
      },
      "America/Miquelon": {
        "long": [
          "സെന്റ് പിയറി ആൻഡ് മിക്വലൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സെന്റ് പിയറി ആൻഡ് മിക്വലൻ ഡേലൈറ്റ് സമയം"
        ]
      },
      "Pacific/Pitcairn": {
        "long": [
          "പിറ്റ്കേൻ സമയം",
          "പിറ്റ്കേൻ സമയം"
        ]
      },
      "Pacific/Ponape": {
        "long": [
          "പൊനാപ്പ് സമയം",
          "പൊനാപ്പ് സമയം"
        ]
      },
      "Asia/Pyongyang": {
        "long": [
          "പ്യോംഗ്‌യാംഗ് സമയം",
          "പ്യോംഗ്‌യാംഗ് സമയം"
        ]
      },
      "Indian/Reunion": {
        "long": [
          "റീയൂണിയൻ സമയം",
          "റീയൂണിയൻ സമയം"
        ]
      },
      "Antarctica/Rothera": {
        "long": [
          "റോഥെറ സമയം",
          "റോഥെറ സമയം"
        ]
      },
      "Asia/Sakhalin": {
        "long": [
          "സഖാലിൻ സ്റ്റാൻഡേർഡ് സമയം",
          "സഖാലിൻ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Pacific/Pago_Pago": {
        "long": [
          "സമോവ സ്റ്റാൻഡേർഡ് സമയം",
          "സമോവാ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Indian/Mahe": {
        "long": [
          "സീഷെൽസ് സമയം",
          "സീഷെൽസ് സമയം"
        ]
      },
      "Asia/Singapore": {
        "long": [
          "സിംഗപ്പൂർ സ്റ്റാൻഡേർഡ് സമയം",
          "സിംഗപ്പൂർ സ്റ്റാൻഡേർഡ് സമയം"
        ]
      },
      "Pacific/Guadalcanal": {
        "long": [
          "സോളമൻ ദ്വീപുകൾ സമയം",
          "സോളമൻ ദ്വീപുകൾ സമയം"
        ]
      },
      "Atlantic/South_Georgia": {
        "long": [
          "ദക്ഷിണ ജോർജ്ജിയൻ സമയം",
          "ദക്ഷിണ ജോർജ്ജിയൻ സമയം"
        ]
      },
      "Asia/Yekaterinburg": {
        "long": [
          "യെക്കാറ്റരിൻബർഗ് സ്റ്റാൻഡേർഡ് സമയം",
          "യെക്കാറ്റരിൻബർഗ് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Antarctica/Syowa": {
        "long": [
          "സയോവ സമയം",
          "സയോവ സമയം"
        ]
      },
      "Pacific/Tahiti": {
        "long": [
          "താഹിതി സമയം",
          "താഹിതി സമയം"
        ]
      },
      "Asia/Taipei": {
        "long": [
          "തായ്‌പെയ് സ്റ്റാൻഡേർഡ് സമയം",
          "തായ്‌പെയ് ഡേലൈറ്റ് സമയം"
        ]
      },
      "Asia/Tashkent": {
        "long": [
          "ഉസ്‌ബെക്കിസ്ഥാൻ സ്റ്റാൻഡേർഡ് സമയം",
          "ഉസ്‌ബെക്കിസ്ഥാൻ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Pacific/Fakaofo": {
        "long": [
          "ടോക്കെലൂ സമയം",
          "ടോക്കെലൂ സമയം"
        ]
      },
      "Pacific/Tongatapu": {
        "long": [
          "ടോംഗ സ്റ്റാൻഡേർഡ് സമയം",
          "ടോംഗ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Pacific/Truk": {
        "long": [
          "ചൂക്ക് സമയം",
          "ചൂക്ക് സമയം"
        ]
      },
      "Pacific/Funafuti": {
        "long": [
          "ടുവാലു സമയം",
          "ടുവാലു സമയം"
        ]
      },
      "America/Montevideo": {
        "long": [
          "ഉറുഗ്വേ സ്റ്റാൻഡേർഡ് സമയം",
          "ഉറുഗ്വേ ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Pacific/Efate": {
        "long": [
          "വന്വാതു സ്റ്റാൻഡേർഡ് സമയം",
          "വന്വാതു ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "America/Caracas": {
        "long": [
          "വെനിസ്വേല സമയം",
          "വെനിസ്വേല സമയം"
        ]
      },
      "Asia/Vladivostok": {
        "long": [
          "വ്ലാഡിവോസ്റ്റോക് സ്റ്റാൻഡേർഡ് സമയം",
          "വ്ലാഡിവോസ്റ്റോക് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Europe/Volgograd": {
        "long": [
          "വോൾഗോഗ്രാഡ് സ്റ്റാൻഡേർഡ് സമയം",
          "വോൾഗോഗ്രാഡ് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "Antarctica/Vostok": {
        "long": [
          "വോസ്റ്റോക് സമയം",
          "വോസ്റ്റോക് സമയം"
        ]
      },
      "Pacific/Wake": {
        "long": [
          "വേക്ക് ദ്വീപ് സമയം",
          "വേക്ക് ദ്വീപ് സമയം"
        ]
      },
      "Pacific/Wallis": {
        "long": [
          "വാലിസ് ആന്റ് ഫ്യൂച്യുന സമയം",
          "വാലിസ് ആന്റ് ഫ്യൂച്യുന സമയം"
        ]
      },
      "Asia/Yakutsk": {
        "long": [
          "യാകസ്‌ക്ക് സ്റ്റാൻഡേർഡ് സമയം",
          "യാകസ്‌ക്ക് ഗ്രീഷ്‌മകാല സമയം"
        ]
      },
      "America/Whitehorse": {
        "long": [
          "യൂക്കോൺ സമയം",
          "യൂക്കോൺ സമയം"
        ]
      },
      "UTC": {
        "long": [
          "കോർഡിനേറ്റഡ് യൂണിവേഴ്‌സൽ സമയം",
          "കോർഡിനേറ്റഡ് യൂണിവേഴ്‌സൽ സമയം"
        ],
        "short": [
          "UTC",
          "UTC"
        ]
      }
    },
    "gmtFormat": "ജിഎംടി {0}",
    "hourFormat": "+HH:mm;-HH:mm",
    "dateFormat": {
      "full": "y, MMMM d, EEEE",
      "long": "y, MMMM d",
      "medium": "y, MMM d",
      "short": "d/M/yy"
    },
    "timeFormat": {
      "full": "h:mm:ss a zzzz",
      "long": "h:mm:ss a z",
      "medium": "h:mm:ss a",
      "short": "h:mm a"
    },
    "dateTimeFormat": {
      "full": "{1} {0}",
      "long": "{1} {0}",
      "medium": "{1} {0}",
      "short": "{1} {0}"
    },
    "formats": {
      "gregory": {
        "Bh": "B h",
        "Bhm": "B h:mm",
        "Bhms": "B h:mm:ss",
        "d": "d",
        "E": "ccc",
        "EBhm": "E, B h:mm",
        "EBhms": "E, B h:mm:ss",
        "Ed": "d, E",
        "Ehm": "E h:mm a",
        "EHm": "E HH:mm",
        "Ehms": "E h:mm:ss a",
        "EHms": "E HH:mm:ss",
        "Gy": "G y",
        "GyMd": "M/d/y GGGGG",
        "GyMMM": "G y MMM",
        "GyMMMd": "G y MMM d",
        "GyMMMEd": "G y MMM d, E",
        "h": "h a",
        "H": "HH",
        "hm": "h:mm a",
        "Hm": "HH:mm",
        "hms": "h:mm:ss a",
        "Hms": "HH:mm:ss",
        "hmsv": "h:mm:ss a v",
        "Hmsv": "HH:mm:ss v",
        "hmv": "h:mm a v",
        "Hmv": "HH:mm v",
        "M": "L",
        "Md": "d/M",
        "MEd": "d/M, E",
        "MMdd": "dd/MM",
        "MMM": "LLL",
        "MMMd": "MMM d",
        "MMMEd": "MMM d, E",
        "MMMMd": "MMMM d",
        "MMMMEd": "MMMM d, E",
        "ms": "mm:ss",
        "y": "y",
        "yM": "y-MM",
        "yMd": "d/M/y",
        "yMEd": "d-M-y, E",
        "yMM": "y-MM",
        "yMMM": "y MMM",
        "yMMMd": "y MMM d",
        "yMMMEd": "y MMM d, E",
        "yMMMM": "y MMMM",
        "y, MMMM d, EEEE": "y, MMMM d, EEEE",
        "y, MMMM d": "y, MMMM d",
        "y, MMM d": "y, MMM d",
        "d/M/yy": "d/M/yy",
        "h:mm:ss a zzzz": "h:mm:ss a zzzz",
        "h:mm:ss a z": "h:mm:ss a z",
        "h:mm:ss a": "h:mm:ss a",
        "h:mm a": "h:mm a",
        "y, MMMM d, EEEE h:mm:ss a zzzz": "y, MMMM d, EEEE h:mm:ss a zzzz",
        "y, MMMM d h:mm:ss a zzzz": "y, MMMM d h:mm:ss a zzzz",
        "y, MMM d h:mm:ss a zzzz": "y, MMM d h:mm:ss a zzzz",
        "d/M/yy h:mm:ss a zzzz": "d/M/yy h:mm:ss a zzzz",
        "d h:mm:ss a zzzz": "d h:mm:ss a zzzz",
        "E h:mm:ss a zzzz": "ccc h:mm:ss a zzzz",
        "Ed h:mm:ss a zzzz": "d, E h:mm:ss a zzzz",
        "Gy h:mm:ss a zzzz": "G y h:mm:ss a zzzz",
        "GyMd h:mm:ss a zzzz": "M/d/y GGGGG h:mm:ss a zzzz",
        "GyMMM h:mm:ss a zzzz": "G y MMM h:mm:ss a zzzz",
        "GyMMMd h:mm:ss a zzzz": "G y MMM d h:mm:ss a zzzz",
        "GyMMMEd h:mm:ss a zzzz": "G y MMM d, E h:mm:ss a zzzz",
        "M h:mm:ss a zzzz": "L h:mm:ss a zzzz",
        "Md h:mm:ss a zzzz": "d/M h:mm:ss a zzzz",
        "MEd h:mm:ss a zzzz": "d/M, E h:mm:ss a zzzz",
        "MMdd h:mm:ss a zzzz": "dd/MM h:mm:ss a zzzz",
        "MMM h:mm:ss a zzzz": "LLL h:mm:ss a zzzz",
        "MMMd h:mm:ss a zzzz": "MMM d h:mm:ss a zzzz",
        "MMMEd h:mm:ss a zzzz": "MMM d, E h:mm:ss a zzzz",
        "MMMMd h:mm:ss a zzzz": "MMMM d h:mm:ss a zzzz",
        "MMMMEd h:mm:ss a zzzz": "MMMM d, E h:mm:ss a zzzz",
        "y h:mm:ss a zzzz": "y h:mm:ss a zzzz",
        "yM h:mm:ss a zzzz": "y-MM h:mm:ss a zzzz",
        "yMd h:mm:ss a zzzz": "d/M/y h:mm:ss a zzzz",
        "yMEd h:mm:ss a zzzz": "d-M-y, E h:mm:ss a zzzz",
        "yMM h:mm:ss a zzzz": "y-MM h:mm:ss a zzzz",
        "yMMM h:mm:ss a zzzz": "y MMM h:mm:ss a zzzz",
        "yMMMd h:mm:ss a zzzz": "y MMM d h:mm:ss a zzzz",
        "yMMMEd h:mm:ss a zzzz": "y MMM d, E h:mm:ss a zzzz",
        "yMMMM h:mm:ss a zzzz": "y MMMM h:mm:ss a zzzz",
        "y, MMMM d, EEEE h:mm:ss a z": "y, MMMM d, EEEE h:mm:ss a z",
        "y, MMMM d h:mm:ss a z": "y, MMMM d h:mm:ss a z",
        "y, MMM d h:mm:ss a z": "y, MMM d h:mm:ss a z",
        "d/M/yy h:mm:ss a z": "d/M/yy h:mm:ss a z",
        "d h:mm:ss a z": "d h:mm:ss a z",
        "E h:mm:ss a z": "ccc h:mm:ss a z",
        "Ed h:mm:ss a z": "d, E h:mm:ss a z",
        "Gy h:mm:ss a z": "G y h:mm:ss a z",
        "GyMd h:mm:ss a z": "M/d/y GGGGG h:mm:ss a z",
        "GyMMM h:mm:ss a z": "G y MMM h:mm:ss a z",
        "GyMMMd h:mm:ss a z": "G y MMM d h:mm:ss a z",
        "GyMMMEd h:mm:ss a z": "G y MMM d, E h:mm:ss a z",
        "M h:mm:ss a z": "L h:mm:ss a z",
        "Md h:mm:ss a z": "d/M h:mm:ss a z",
        "MEd h:mm:ss a z": "d/M, E h:mm:ss a z",
        "MMdd h:mm:ss a z": "dd/MM h:mm:ss a z",
        "MMM h:mm:ss a z": "LLL h:mm:ss a z",
        "MMMd h:mm:ss a z": "MMM d h:mm:ss a z",
        "MMMEd h:mm:ss a z": "MMM d, E h:mm:ss a z",
        "MMMMd h:mm:ss a z": "MMMM d h:mm:ss a z",
        "MMMMEd h:mm:ss a z": "MMMM d, E h:mm:ss a z",
        "y h:mm:ss a z": "y h:mm:ss a z",
        "yM h:mm:ss a z": "y-MM h:mm:ss a z",
        "yMd h:mm:ss a z": "d/M/y h:mm:ss a z",
        "yMEd h:mm:ss a z": "d-M-y, E h:mm:ss a z",
        "yMM h:mm:ss a z": "y-MM h:mm:ss a z",
        "yMMM h:mm:ss a z": "y MMM h:mm:ss a z",
        "yMMMd h:mm:ss a z": "y MMM d h:mm:ss a z",
        "yMMMEd h:mm:ss a z": "y MMM d, E h:mm:ss a z",
        "yMMMM h:mm:ss a z": "y MMMM h:mm:ss a z",
        "y, MMMM d, EEEE h:mm:ss a": "y, MMMM d, EEEE h:mm:ss a",
        "y, MMMM d h:mm:ss a": "y, MMMM d h:mm:ss a",
        "y, MMM d h:mm:ss a": "y, MMM d h:mm:ss a",
        "d/M/yy h:mm:ss a": "d/M/yy h:mm:ss a",
        "d h:mm:ss a": "d h:mm:ss a",
        "E h:mm:ss a": "ccc h:mm:ss a",
        "Ed h:mm:ss a": "d, E h:mm:ss a",
        "Gy h:mm:ss a": "G y h:mm:ss a",
        "GyMd h:mm:ss a": "M/d/y GGGGG h:mm:ss a",
        "GyMMM h:mm:ss a": "G y MMM h:mm:ss a",
        "GyMMMd h:mm:ss a": "G y MMM d h:mm:ss a",
        "GyMMMEd h:mm:ss a": "G y MMM d, E h:mm:ss a",
        "M h:mm:ss a": "L h:mm:ss a",
        "Md h:mm:ss a": "d/M h:mm:ss a",
        "MEd h:mm:ss a": "d/M, E h:mm:ss a",
        "MMdd h:mm:ss a": "dd/MM h:mm:ss a",
        "MMM h:mm:ss a": "LLL h:mm:ss a",
        "MMMd h:mm:ss a": "MMM d h:mm:ss a",
        "MMMEd h:mm:ss a": "MMM d, E h:mm:ss a",
        "MMMMd h:mm:ss a": "MMMM d h:mm:ss a",
        "MMMMEd h:mm:ss a": "MMMM d, E h:mm:ss a",
        "y h:mm:ss a": "y h:mm:ss a",
        "yM h:mm:ss a": "y-MM h:mm:ss a",
        "yMd h:mm:ss a": "d/M/y h:mm:ss a",
        "yMEd h:mm:ss a": "d-M-y, E h:mm:ss a",
        "yMM h:mm:ss a": "y-MM h:mm:ss a",
        "yMMM h:mm:ss a": "y MMM h:mm:ss a",
        "yMMMd h:mm:ss a": "y MMM d h:mm:ss a",
        "yMMMEd h:mm:ss a": "y MMM d, E h:mm:ss a",
        "yMMMM h:mm:ss a": "y MMMM h:mm:ss a",
        "y, MMMM d, EEEE h:mm a": "y, MMMM d, EEEE h:mm a",
        "y, MMMM d h:mm a": "y, MMMM d h:mm a",
        "y, MMM d h:mm a": "y, MMM d h:mm a",
        "d/M/yy h:mm a": "d/M/yy h:mm a",
        "d h:mm a": "d h:mm a",
        "E h:mm a": "ccc h:mm a",
        "Ed h:mm a": "d, E h:mm a",
        "Gy h:mm a": "G y h:mm a",
        "GyMd h:mm a": "M/d/y GGGGG h:mm a",
        "GyMMM h:mm a": "G y MMM h:mm a",
        "GyMMMd h:mm a": "G y MMM d h:mm a",
        "GyMMMEd h:mm a": "G y MMM d, E h:mm a",
        "M h:mm a": "L h:mm a",
        "Md h:mm a": "d/M h:mm a",
        "MEd h:mm a": "d/M, E h:mm a",
        "MMdd h:mm a": "dd/MM h:mm a",
        "MMM h:mm a": "LLL h:mm a",
        "MMMd h:mm a": "MMM d h:mm a",
        "MMMEd h:mm a": "MMM d, E h:mm a",
        "MMMMd h:mm a": "MMMM d h:mm a",
        "MMMMEd h:mm a": "MMMM d, E h:mm a",
        "y h:mm a": "y h:mm a",
        "yM h:mm a": "y-MM h:mm a",
        "yMd h:mm a": "d/M/y h:mm a",
        "yMEd h:mm a": "d-M-y, E h:mm a",
        "yMM h:mm a": "y-MM h:mm a",
        "yMMM h:mm a": "y MMM h:mm a",
        "yMMMd h:mm a": "y MMM d h:mm a",
        "yMMMEd h:mm a": "y MMM d, E h:mm a",
        "yMMMM h:mm a": "y MMMM h:mm a",
        "y, MMMM d, EEEE Bh": "y, MMMM d, EEEE B h",
        "y, MMMM d Bh": "y, MMMM d B h",
        "y, MMM d Bh": "y, MMM d B h",
        "d/M/yy Bh": "d/M/yy B h",
        "d Bh": "d B h",
        "E Bh": "ccc B h",
        "Ed Bh": "d, E B h",
        "Gy Bh": "G y B h",
        "GyMd Bh": "M/d/y GGGGG B h",
        "GyMMM Bh": "G y MMM B h",
        "GyMMMd Bh": "G y MMM d B h",
        "GyMMMEd Bh": "G y MMM d, E B h",
        "M Bh": "L B h",
        "Md Bh": "d/M B h",
        "MEd Bh": "d/M, E B h",
        "MMdd Bh": "dd/MM B h",
        "MMM Bh": "LLL B h",
        "MMMd Bh": "MMM d B h",
        "MMMEd Bh": "MMM d, E B h",
        "MMMMd Bh": "MMMM d B h",
        "MMMMEd Bh": "MMMM d, E B h",
        "y Bh": "y B h",
        "yM Bh": "y-MM B h",
        "yMd Bh": "d/M/y B h",
        "yMEd Bh": "d-M-y, E B h",
        "yMM Bh": "y-MM B h",
        "yMMM Bh": "y MMM B h",
        "yMMMd Bh": "y MMM d B h",
        "yMMMEd Bh": "y MMM d, E B h",
        "yMMMM Bh": "y MMMM B h",
        "y, MMMM d, EEEE Bhm": "y, MMMM d, EEEE B h:mm",
        "y, MMMM d Bhm": "y, MMMM d B h:mm",
        "y, MMM d Bhm": "y, MMM d B h:mm",
        "d/M/yy Bhm": "d/M/yy B h:mm",
        "d Bhm": "d B h:mm",
        "E Bhm": "ccc B h:mm",
        "Ed Bhm": "d, E B h:mm",
        "Gy Bhm": "G y B h:mm",
        "GyMd Bhm": "M/d/y GGGGG B h:mm",
        "GyMMM Bhm": "G y MMM B h:mm",
        "GyMMMd Bhm": "G y MMM d B h:mm",
        "GyMMMEd Bhm": "G y MMM d, E B h:mm",
        "M Bhm": "L B h:mm",
        "Md Bhm": "d/M B h:mm",
        "MEd Bhm": "d/M, E B h:mm",
        "MMdd Bhm": "dd/MM B h:mm",
        "MMM Bhm": "LLL B h:mm",
        "MMMd Bhm": "MMM d B h:mm",
        "MMMEd Bhm": "MMM d, E B h:mm",
        "MMMMd Bhm": "MMMM d B h:mm",
        "MMMMEd Bhm": "MMMM d, E B h:mm",
        "y Bhm": "y B h:mm",
        "yM Bhm": "y-MM B h:mm",
        "yMd Bhm": "d/M/y B h:mm",
        "yMEd Bhm": "d-M-y, E B h:mm",
        "yMM Bhm": "y-MM B h:mm",
        "yMMM Bhm": "y MMM B h:mm",
        "yMMMd Bhm": "y MMM d B h:mm",
        "yMMMEd Bhm": "y MMM d, E B h:mm",
        "yMMMM Bhm": "y MMMM B h:mm",
        "y, MMMM d, EEEE Bhms": "y, MMMM d, EEEE B h:mm:ss",
        "y, MMMM d Bhms": "y, MMMM d B h:mm:ss",
        "y, MMM d Bhms": "y, MMM d B h:mm:ss",
        "d/M/yy Bhms": "d/M/yy B h:mm:ss",
        "d Bhms": "d B h:mm:ss",
        "E Bhms": "ccc B h:mm:ss",
        "Ed Bhms": "d, E B h:mm:ss",
        "Gy Bhms": "G y B h:mm:ss",
        "GyMd Bhms": "M/d/y GGGGG B h:mm:ss",
        "GyMMM Bhms": "G y MMM B h:mm:ss",
        "GyMMMd Bhms": "G y MMM d B h:mm:ss",
        "GyMMMEd Bhms": "G y MMM d, E B h:mm:ss",
        "M Bhms": "L B h:mm:ss",
        "Md Bhms": "d/M B h:mm:ss",
        "MEd Bhms": "d/M, E B h:mm:ss",
        "MMdd Bhms": "dd/MM B h:mm:ss",
        "MMM Bhms": "LLL B h:mm:ss",
        "MMMd Bhms": "MMM d B h:mm:ss",
        "MMMEd Bhms": "MMM d, E B h:mm:ss",
        "MMMMd Bhms": "MMMM d B h:mm:ss",
        "MMMMEd Bhms": "MMMM d, E B h:mm:ss",
        "y Bhms": "y B h:mm:ss",
        "yM Bhms": "y-MM B h:mm:ss",
        "yMd Bhms": "d/M/y B h:mm:ss",
        "yMEd Bhms": "d-M-y, E B h:mm:ss",
        "yMM Bhms": "y-MM B h:mm:ss",
        "yMMM Bhms": "y MMM B h:mm:ss",
        "yMMMd Bhms": "y MMM d B h:mm:ss",
        "yMMMEd Bhms": "y MMM d, E B h:mm:ss",
        "yMMMM Bhms": "y MMMM B h:mm:ss",
        "y, MMMM d, EEEE h": "y, MMMM d, EEEE h a",
        "y, MMMM d h": "y, MMMM d h a",
        "y, MMM d h": "y, MMM d h a",
        "d/M/yy h": "d/M/yy h a",
        "d h": "d h a",
        "E h": "ccc h a",
        "Ed h": "d, E h a",
        "Gy h": "G y h a",
        "GyMd h": "M/d/y GGGGG h a",
        "GyMMM h": "G y MMM h a",
        "GyMMMd h": "G y MMM d h a",
        "GyMMMEd h": "G y MMM d, E h a",
        "M h": "L h a",
        "Md h": "d/M h a",
        "MEd h": "d/M, E h a",
        "MMdd h": "dd/MM h a",
        "MMM h": "LLL h a",
        "MMMd h": "MMM d h a",
        "MMMEd h": "MMM d, E h a",
        "MMMMd h": "MMMM d h a",
        "MMMMEd h": "MMMM d, E h a",
        "y h": "y h a",
        "yM h": "y-MM h a",
        "yMd h": "d/M/y h a",
        "yMEd h": "d-M-y, E h a",
        "yMM h": "y-MM h a",
        "yMMM h": "y MMM h a",
        "yMMMd h": "y MMM d h a",
        "yMMMEd h": "y MMM d, E h a",
        "yMMMM h": "y MMMM h a",
        "y, MMMM d, EEEE H": "y, MMMM d, EEEE HH",
        "y, MMMM d H": "y, MMMM d HH",
        "y, MMM d H": "y, MMM d HH",
        "d/M/yy H": "d/M/yy HH",
        "d H": "d HH",
        "E H": "ccc HH",
        "Ed H": "d, E HH",
        "Gy H": "G y HH",
        "GyMd H": "M/d/y GGGGG HH",
        "GyMMM H": "G y MMM HH",
        "GyMMMd H": "G y MMM d HH",
        "GyMMMEd H": "G y MMM d, E HH",
        "M H": "L HH",
        "Md H": "d/M HH",
        "MEd H": "d/M, E HH",
        "MMdd H": "dd/MM HH",
        "MMM H": "LLL HH",
        "MMMd H": "MMM d HH",
        "MMMEd H": "MMM d, E HH",
        "MMMMd H": "MMMM d HH",
        "MMMMEd H": "MMMM d, E HH",
        "y H": "y HH",
        "yM H": "y-MM HH",
        "yMd H": "d/M/y HH",
        "yMEd H": "d-M-y, E HH",
        "yMM H": "y-MM HH",
        "yMMM H": "y MMM HH",
        "yMMMd H": "y MMM d HH",
        "yMMMEd H": "y MMM d, E HH",
        "yMMMM H": "y MMMM HH",
        "y, MMMM d, EEEE hm": "y, MMMM d, EEEE h:mm a",
        "y, MMMM d hm": "y, MMMM d h:mm a",
        "y, MMM d hm": "y, MMM d h:mm a",
        "d/M/yy hm": "d/M/yy h:mm a",
        "d hm": "d h:mm a",
        "E hm": "ccc h:mm a",
        "Ed hm": "d, E h:mm a",
        "Gy hm": "G y h:mm a",
        "GyMd hm": "M/d/y GGGGG h:mm a",
        "GyMMM hm": "G y MMM h:mm a",
        "GyMMMd hm": "G y MMM d h:mm a",
        "GyMMMEd hm": "G y MMM d, E h:mm a",
        "M hm": "L h:mm a",
        "Md hm": "d/M h:mm a",
        "MEd hm": "d/M, E h:mm a",
        "MMdd hm": "dd/MM h:mm a",
        "MMM hm": "LLL h:mm a",
        "MMMd hm": "MMM d h:mm a",
        "MMMEd hm": "MMM d, E h:mm a",
        "MMMMd hm": "MMMM d h:mm a",
        "MMMMEd hm": "MMMM d, E h:mm a",
        "y hm": "y h:mm a",
        "yM hm": "y-MM h:mm a",
        "yMd hm": "d/M/y h:mm a",
        "yMEd hm": "d-M-y, E h:mm a",
        "yMM hm": "y-MM h:mm a",
        "yMMM hm": "y MMM h:mm a",
        "yMMMd hm": "y MMM d h:mm a",
        "yMMMEd hm": "y MMM d, E h:mm a",
        "yMMMM hm": "y MMMM h:mm a",
        "y, MMMM d, EEEE Hm": "y, MMMM d, EEEE HH:mm",
        "y, MMMM d Hm": "y, MMMM d HH:mm",
        "y, MMM d Hm": "y, MMM d HH:mm",
        "d/M/yy Hm": "d/M/yy HH:mm",
        "d Hm": "d HH:mm",
        "E Hm": "ccc HH:mm",
        "Ed Hm": "d, E HH:mm",
        "Gy Hm": "G y HH:mm",
        "GyMd Hm": "M/d/y GGGGG HH:mm",
        "GyMMM Hm": "G y MMM HH:mm",
        "GyMMMd Hm": "G y MMM d HH:mm",
        "GyMMMEd Hm": "G y MMM d, E HH:mm",
        "M Hm": "L HH:mm",
        "Md Hm": "d/M HH:mm",
        "MEd Hm": "d/M, E HH:mm",
        "MMdd Hm": "dd/MM HH:mm",
        "MMM Hm": "LLL HH:mm",
        "MMMd Hm": "MMM d HH:mm",
        "MMMEd Hm": "MMM d, E HH:mm",
        "MMMMd Hm": "MMMM d HH:mm",
        "MMMMEd Hm": "MMMM d, E HH:mm",
        "y Hm": "y HH:mm",
        "yM Hm": "y-MM HH:mm",
        "yMd Hm": "d/M/y HH:mm",
        "yMEd Hm": "d-M-y, E HH:mm",
        "yMM Hm": "y-MM HH:mm",
        "yMMM Hm": "y MMM HH:mm",
        "yMMMd Hm": "y MMM d HH:mm",
        "yMMMEd Hm": "y MMM d, E HH:mm",
        "yMMMM Hm": "y MMMM HH:mm",
        "y, MMMM d, EEEE hms": "y, MMMM d, EEEE h:mm:ss a",
        "y, MMMM d hms": "y, MMMM d h:mm:ss a",
        "y, MMM d hms": "y, MMM d h:mm:ss a",
        "d/M/yy hms": "d/M/yy h:mm:ss a",
        "d hms": "d h:mm:ss a",
        "E hms": "ccc h:mm:ss a",
        "Ed hms": "d, E h:mm:ss a",
        "Gy hms": "G y h:mm:ss a",
        "GyMd hms": "M/d/y GGGGG h:mm:ss a",
        "GyMMM hms": "G y MMM h:mm:ss a",
        "GyMMMd hms": "G y MMM d h:mm:ss a",
        "GyMMMEd hms": "G y MMM d, E h:mm:ss a",
        "M hms": "L h:mm:ss a",
        "Md hms": "d/M h:mm:ss a",
        "MEd hms": "d/M, E h:mm:ss a",
        "MMdd hms": "dd/MM h:mm:ss a",
        "MMM hms": "LLL h:mm:ss a",
        "MMMd hms": "MMM d h:mm:ss a",
        "MMMEd hms": "MMM d, E h:mm:ss a",
        "MMMMd hms": "MMMM d h:mm:ss a",
        "MMMMEd hms": "MMMM d, E h:mm:ss a",
        "y hms": "y h:mm:ss a",
        "yM hms": "y-MM h:mm:ss a",
        "yMd hms": "d/M/y h:mm:ss a",
        "yMEd hms": "d-M-y, E h:mm:ss a",
        "yMM hms": "y-MM h:mm:ss a",
        "yMMM hms": "y MMM h:mm:ss a",
        "yMMMd hms": "y MMM d h:mm:ss a",
        "yMMMEd hms": "y MMM d, E h:mm:ss a",
        "yMMMM hms": "y MMMM h:mm:ss a",
        "y, MMMM d, EEEE Hms": "y, MMMM d, EEEE HH:mm:ss",
        "y, MMMM d Hms": "y, MMMM d HH:mm:ss",
        "y, MMM d Hms": "y, MMM d HH:mm:ss",
        "d/M/yy Hms": "d/M/yy HH:mm:ss",
        "d Hms": "d HH:mm:ss",
        "E Hms": "ccc HH:mm:ss",
        "Ed Hms": "d, E HH:mm:ss",
        "Gy Hms": "G y HH:mm:ss",
        "GyMd Hms": "M/d/y GGGGG HH:mm:ss",
        "GyMMM Hms": "G y MMM HH:mm:ss",
        "GyMMMd Hms": "G y MMM d HH:mm:ss",
        "GyMMMEd Hms": "G y MMM d, E HH:mm:ss",
        "M Hms": "L HH:mm:ss",
        "Md Hms": "d/M HH:mm:ss",
        "MEd Hms": "d/M, E HH:mm:ss",
        "MMdd Hms": "dd/MM HH:mm:ss",
        "MMM Hms": "LLL HH:mm:ss",
        "MMMd Hms": "MMM d HH:mm:ss",
        "MMMEd Hms": "MMM d, E HH:mm:ss",
        "MMMMd Hms": "MMMM d HH:mm:ss",
        "MMMMEd Hms": "MMMM d, E HH:mm:ss",
        "y Hms": "y HH:mm:ss",
        "yM Hms": "y-MM HH:mm:ss",
        "yMd Hms": "d/M/y HH:mm:ss",
        "yMEd Hms": "d-M-y, E HH:mm:ss",
        "yMM Hms": "y-MM HH:mm:ss",
        "yMMM Hms": "y MMM HH:mm:ss",
        "yMMMd Hms": "y MMM d HH:mm:ss",
        "yMMMEd Hms": "y MMM d, E HH:mm:ss",
        "yMMMM Hms": "y MMMM HH:mm:ss",
        "y, MMMM d, EEEE hmsv": "y, MMMM d, EEEE h:mm:ss a v",
        "y, MMMM d hmsv": "y, MMMM d h:mm:ss a v",
        "y, MMM d hmsv": "y, MMM d h:mm:ss a v",
        "d/M/yy hmsv": "d/M/yy h:mm:ss a v",
        "d hmsv": "d h:mm:ss a v",
        "E hmsv": "ccc h:mm:ss a v",
        "Ed hmsv": "d, E h:mm:ss a v",
        "Gy hmsv": "G y h:mm:ss a v",
        "GyMd hmsv": "M/d/y GGGGG h:mm:ss a v",
        "GyMMM hmsv": "G y MMM h:mm:ss a v",
        "GyMMMd hmsv": "G y MMM d h:mm:ss a v",
        "GyMMMEd hmsv": "G y MMM d, E h:mm:ss a v",
        "M hmsv": "L h:mm:ss a v",
        "Md hmsv": "d/M h:mm:ss a v",
        "MEd hmsv": "d/M, E h:mm:ss a v",
        "MMdd hmsv": "dd/MM h:mm:ss a v",
        "MMM hmsv": "LLL h:mm:ss a v",
        "MMMd hmsv": "MMM d h:mm:ss a v",
        "MMMEd hmsv": "MMM d, E h:mm:ss a v",
        "MMMMd hmsv": "MMMM d h:mm:ss a v",
        "MMMMEd hmsv": "MMMM d, E h:mm:ss a v",
        "y hmsv": "y h:mm:ss a v",
        "yM hmsv": "y-MM h:mm:ss a v",
        "yMd hmsv": "d/M/y h:mm:ss a v",
        "yMEd hmsv": "d-M-y, E h:mm:ss a v",
        "yMM hmsv": "y-MM h:mm:ss a v",
        "yMMM hmsv": "y MMM h:mm:ss a v",
        "yMMMd hmsv": "y MMM d h:mm:ss a v",
        "yMMMEd hmsv": "y MMM d, E h:mm:ss a v",
        "yMMMM hmsv": "y MMMM h:mm:ss a v",
        "y, MMMM d, EEEE Hmsv": "y, MMMM d, EEEE HH:mm:ss v",
        "y, MMMM d Hmsv": "y, MMMM d HH:mm:ss v",
        "y, MMM d Hmsv": "y, MMM d HH:mm:ss v",
        "d/M/yy Hmsv": "d/M/yy HH:mm:ss v",
        "d Hmsv": "d HH:mm:ss v",
        "E Hmsv": "ccc HH:mm:ss v",
        "Ed Hmsv": "d, E HH:mm:ss v",
        "Gy Hmsv": "G y HH:mm:ss v",
        "GyMd Hmsv": "M/d/y GGGGG HH:mm:ss v",
        "GyMMM Hmsv": "G y MMM HH:mm:ss v",
        "GyMMMd Hmsv": "G y MMM d HH:mm:ss v",
        "GyMMMEd Hmsv": "G y MMM d, E HH:mm:ss v",
        "M Hmsv": "L HH:mm:ss v",
        "Md Hmsv": "d/M HH:mm:ss v",
        "MEd Hmsv": "d/M, E HH:mm:ss v",
        "MMdd Hmsv": "dd/MM HH:mm:ss v",
        "MMM Hmsv": "LLL HH:mm:ss v",
        "MMMd Hmsv": "MMM d HH:mm:ss v",
        "MMMEd Hmsv": "MMM d, E HH:mm:ss v",
        "MMMMd Hmsv": "MMMM d HH:mm:ss v",
        "MMMMEd Hmsv": "MMMM d, E HH:mm:ss v",
        "y Hmsv": "y HH:mm:ss v",
        "yM Hmsv": "y-MM HH:mm:ss v",
        "yMd Hmsv": "d/M/y HH:mm:ss v",
        "yMEd Hmsv": "d-M-y, E HH:mm:ss v",
        "yMM Hmsv": "y-MM HH:mm:ss v",
        "yMMM Hmsv": "y MMM HH:mm:ss v",
        "yMMMd Hmsv": "y MMM d HH:mm:ss v",
        "yMMMEd Hmsv": "y MMM d, E HH:mm:ss v",
        "yMMMM Hmsv": "y MMMM HH:mm:ss v",
        "y, MMMM d, EEEE hmv": "y, MMMM d, EEEE h:mm a v",
        "y, MMMM d hmv": "y, MMMM d h:mm a v",
        "y, MMM d hmv": "y, MMM d h:mm a v",
        "d/M/yy hmv": "d/M/yy h:mm a v",
        "d hmv": "d h:mm a v",
        "E hmv": "ccc h:mm a v",
        "Ed hmv": "d, E h:mm a v",
        "Gy hmv": "G y h:mm a v",
        "GyMd hmv": "M/d/y GGGGG h:mm a v",
        "GyMMM hmv": "G y MMM h:mm a v",
        "GyMMMd hmv": "G y MMM d h:mm a v",
        "GyMMMEd hmv": "G y MMM d, E h:mm a v",
        "M hmv": "L h:mm a v",
        "Md hmv": "d/M h:mm a v",
        "MEd hmv": "d/M, E h:mm a v",
        "MMdd hmv": "dd/MM h:mm a v",
        "MMM hmv": "LLL h:mm a v",
        "MMMd hmv": "MMM d h:mm a v",
        "MMMEd hmv": "MMM d, E h:mm a v",
        "MMMMd hmv": "MMMM d h:mm a v",
        "MMMMEd hmv": "MMMM d, E h:mm a v",
        "y hmv": "y h:mm a v",
        "yM hmv": "y-MM h:mm a v",
        "yMd hmv": "d/M/y h:mm a v",
        "yMEd hmv": "d-M-y, E h:mm a v",
        "yMM hmv": "y-MM h:mm a v",
        "yMMM hmv": "y MMM h:mm a v",
        "yMMMd hmv": "y MMM d h:mm a v",
        "yMMMEd hmv": "y MMM d, E h:mm a v",
        "yMMMM hmv": "y MMMM h:mm a v",
        "y, MMMM d, EEEE Hmv": "y, MMMM d, EEEE HH:mm v",
        "y, MMMM d Hmv": "y, MMMM d HH:mm v",
        "y, MMM d Hmv": "y, MMM d HH:mm v",
        "d/M/yy Hmv": "d/M/yy HH:mm v",
        "d Hmv": "d HH:mm v",
        "E Hmv": "ccc HH:mm v",
        "Ed Hmv": "d, E HH:mm v",
        "Gy Hmv": "G y HH:mm v",
        "GyMd Hmv": "M/d/y GGGGG HH:mm v",
        "GyMMM Hmv": "G y MMM HH:mm v",
        "GyMMMd Hmv": "G y MMM d HH:mm v",
        "GyMMMEd Hmv": "G y MMM d, E HH:mm v",
        "M Hmv": "L HH:mm v",
        "Md Hmv": "d/M HH:mm v",
        "MEd Hmv": "d/M, E HH:mm v",
        "MMdd Hmv": "dd/MM HH:mm v",
        "MMM Hmv": "LLL HH:mm v",
        "MMMd Hmv": "MMM d HH:mm v",
        "MMMEd Hmv": "MMM d, E HH:mm v",
        "MMMMd Hmv": "MMMM d HH:mm v",
        "MMMMEd Hmv": "MMMM d, E HH:mm v",
        "y Hmv": "y HH:mm v",
        "yM Hmv": "y-MM HH:mm v",
        "yMd Hmv": "d/M/y HH:mm v",
        "yMEd Hmv": "d-M-y, E HH:mm v",
        "yMM Hmv": "y-MM HH:mm v",
        "yMMM Hmv": "y MMM HH:mm v",
        "yMMMd Hmv": "y MMM d HH:mm v",
        "yMMMEd Hmv": "y MMM d, E HH:mm v",
        "yMMMM Hmv": "y MMMM HH:mm v",
        "y, MMMM d, EEEE ms": "y, MMMM d, EEEE mm:ss",
        "y, MMMM d ms": "y, MMMM d mm:ss",
        "y, MMM d ms": "y, MMM d mm:ss",
        "d/M/yy ms": "d/M/yy mm:ss",
        "d ms": "d mm:ss",
        "E ms": "ccc mm:ss",
        "Ed ms": "d, E mm:ss",
        "Gy ms": "G y mm:ss",
        "GyMd ms": "M/d/y GGGGG mm:ss",
        "GyMMM ms": "G y MMM mm:ss",
        "GyMMMd ms": "G y MMM d mm:ss",
        "GyMMMEd ms": "G y MMM d, E mm:ss",
        "M ms": "L mm:ss",
        "Md ms": "d/M mm:ss",
        "MEd ms": "d/M, E mm:ss",
        "MMdd ms": "dd/MM mm:ss",
        "MMM ms": "LLL mm:ss",
        "MMMd ms": "MMM d mm:ss",
        "MMMEd ms": "MMM d, E mm:ss",
        "MMMMd ms": "MMMM d mm:ss",
        "MMMMEd ms": "MMMM d, E mm:ss",
        "y ms": "y mm:ss",
        "yM ms": "y-MM mm:ss",
        "yMd ms": "d/M/y mm:ss",
        "yMEd ms": "d-M-y, E mm:ss",
        "yMM ms": "y-MM mm:ss",
        "yMMM ms": "y MMM mm:ss",
        "yMMMd ms": "y MMM d mm:ss",
        "yMMMEd ms": "y MMM d, E mm:ss",
        "yMMMM ms": "y MMMM mm:ss"
      }
    },
    "intervalFormats": {
      "intervalFormatFallback": "{0} - {1}",
      "Bh": {
        "B": "B h – B h",
        "h": "h–h B"
      },
      "Bhm": {
        "B": "B h:mm – B h:mm",
        "h": "B h:mm – h:mm",
        "m": "B h:mm – h:mm"
      },
      "d": {
        "d": "d – d"
      },
      "Gy": {
        "G": "G y – G y",
        "y": "G y–y"
      },
      "GyM": {
        "G": "GGGGG y-MM – GGGGG y-MM",
        "M": "GGGGG y-MM – y-MM",
        "y": "GGGGG y-MM – y-MM"
      },
      "GyMd": {
        "d": "GGGGG y-MM-dd – y-MM-dd",
        "G": "GGGGG y-MM-dd – GGGGG y-MM-dd",
        "M": "GGGGG y-MM-dd – y-MM-dd",
        "y": "GGGGG y-MM-dd – y-MM-dd"
      },
      "GyMEd": {
        "d": "GGGGG y-MM-dd, E – y-MM-dd, E",
        "G": "GGGGG y-MM-dd, E – GGGGG y-MM-dd, E",
        "M": "GGGGG y-MM-dd, E – y-MM-dd, E",
        "y": "GGGGG y-MM-dd, E – y-MM-dd, E"
      },
      "GyMMM": {
        "G": "G y MMM – G y MMM",
        "M": "G y MMM–MMM",
        "y": "G y MMM – y MMM"
      },
      "GyMMMd": {
        "d": "G y MMM d–d",
        "G": "G y MMM d – G y MMM d",
        "M": "G y MMM d – MMM d",
        "y": "G y MMM d – y MMM d"
      },
      "GyMMMEd": {
        "d": "G y MMM d, E – MMM d, E",
        "G": "G y MMM d, E – G y MMM d, E",
        "M": "G y MMM d, E – MMM d, E",
        "y": "G y MMM d, E – y MMM d, E"
      },
      "h": {
        "a": "h a – h a",
        "h": "h – h a"
      },
      "H": {
        "H": "HH – HH"
      },
      "hm": {
        "a": "h:mm a – h:mm a",
        "h": "h:mm – h:mm a",
        "m": "h:mm – h:mm a"
      },
      "Hm": {
        "H": "HH:mm – HH:mm",
        "m": "HH:mm – HH:mm"
      },
      "hmv": {
        "a": "h:mm a – h:mm a v",
        "h": "h:mm – h:mm a v",
        "m": "h:mm – h:mm a v"
      },
      "Hmv": {
        "H": "HH:mm – HH:mm v",
        "m": "HH:mm – HH:mm v"
      },
      "hv": {
        "a": "h a – h a v",
        "h": "h – h a v"
      },
      "Hv": {
        "H": "HH – HH v"
      },
      "M": {
        "M": "MM–MM"
      },
      "Md": {
        "d": "d/M – d/M",
        "M": "d/M – d/M"
      },
      "MEd": {
        "d": "d/M, E – d/M, E",
        "M": "d/M, E – d/M, E"
      },
      "MMM": {
        "M": "MMM – MMM"
      },
      "MMMd": {
        "d": "MMM d – d",
        "M": "MMM d – MMM d"
      },
      "MMMEd": {
        "d": "MMM d, E – MMM d, E",
        "M": "MMM d, E – MMM d, E"
      },
      "MMMM": {
        "M": "MMMM – MMMM"
      },
      "y": {
        "y": "y – y"
      },
      "yM": {
        "M": "M/y – M/y",
        "y": "M/y – M/y"
      },
      "yMd": {
        "d": "d/M/y – d/M/y",
        "M": "d/M/y – d/M/y",
        "y": "d/M/y – d/M/y"
      },
      "yMEd": {
        "d": "d/M/y, E – d/M/y, E",
        "M": "d/M/y, E – d/M/y, E",
        "y": "d/M/y, E – d/M/y, E"
      },
      "yMMM": {
        "M": "y MMM – MMM",
        "y": "y MMM – y MMM"
      },
      "yMMMd": {
        "d": "y MMM d – d",
        "M": "y MMM d – MMM d",
        "y": "y MMM d – y MMM d"
      },
      "yMMMEd": {
        "d": "y MMM d, E – MMM d, E",
        "M": "y MMM d, E – MMM d, E",
        "y": "y MMM d, E – y MMM d, E"
      },
      "yMMMM": {
        "M": "y MMMM–MMMM",
        "y": "y MMMM – y MMMM"
      }
    },
    "hourCycle": "h12",
    "nu": [
      "latn"
    ],
    "ca": [
      "gregory",
      "indian"
    ],
    "hc": [
      "h12",
      "h23"
    ]
  },
  "locale": "ml"
}
)
}
